import React from "react"
import buffer from "../assets/loading-buffering.gif"

function Loading() {
  return (
    <div className="loading">
      <img src={buffer} alt="Buffering" width="20%" />
      <br /> <br />
      <p> Loading... </p>
    </div>
  )
}

export default Loading
